import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import FileDownloadIcon from '@mui/icons-material/FileDownload';


import "./HomePage.css";
import Navbar from "./Navbar";

const HomePage = () => {
  return (
    <div className="home-page-container">
      <div className="home-page-header">
        <Navbar />
      </div>
      <div className="home-page">
        <div>
          <span>hey,</span>
          <p>
            this is<span> Akarsh</span>,
          </p>
        </div>
        <span>a full-stack developer. </span>
       
      </div>
      <div className="home-page-footer">
        <a
          href="https://github.com/akarshmi"
          target="_blank"
          rel="noopener noreferrer"
        >
          <GitHubIcon />
        </a>
        <a
          href="https://www.linkedin.com/in/akarshmi"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LinkedInIcon />
        </a>
        <a
          href="https://www.instagram.com/akarshmi/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <InstagramIcon />
        </a>
            
        <a href="https://www.x.com/akarshmi/"
            target="_blank"
          rel="noopener noreferrer"
        >
          <TwitterIcon />
            </a>
  

            <a
          href="/latestresume.pdf"
            target="_blank"
          rel="noopener noreferrer"
        >
          <FileDownloadIcon />
        </a>
            
       </div>
    </div>
  );
};

export default HomePage;
